export default __webpack_public_path__ + "static/media/winnerGif.12d55b19.gif";